// styling
import styles from "./style.module.scss";

// components
import LazyImage from "@components/LazyImage";
import Spring from "@components/Spring";
import api from "@utils/api";

const ItemsGridItem = ({ item, index }) => {
  const { image } = item;

  const token = localStorage.getItem("token");

  const addImageForCanvas = () => {
    const formData = new FormData();
    formData.append("image", item.id);
    formData.append("selected", "True");

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    };

    api
      .put("/select-images", formData, { headers })
      .then((res) => {
        if (res?.data?.status == "200") {
          localStorage.setItem("showSuccessToast", true);
        }

        console.log(res);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <Spring index={index}>
      <div className={`${styles.wrapper} border-hover bg-primary`}>
        <div className={`${styles.media} square border-10`}>
          <LazyImage
            src={image}
           // src={`http://127.0.0.1:8000${image}`}
            alt="Item Image"
          />
        </div>
        <button className="btn btn--gradient w-100" onClick={addImageForCanvas}>
          Add to Canvas
        </button>
      </div>
    </Spring>
  );
};

export default ItemsGridItem;
